/** @jsxImportSource @emotion/react */

import React from 'react';
import styled from 'styled-components';
import Scroll from '@component/common/scroll';
import Line from '@component/common/line';
import * as size from '@constant/size';
import { IS_IYAGIGO_MOBILE_VIEW } from '@config/environment';
import * as color from '@constant/color';
import TextBlock from '@component/common/block/text-block';
import Gap from '@component/common/gap';
import { useTypedSelector } from '@hook/common/useStore';
import { useNavigate } from 'react-router-dom';
import { IYAGIGO_PATH } from '@constant/iyagigo/route-path';
import IconBlock from '@component/common/block/icon-block';

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: ${size.PAGE_PADDING};
`;

const HubContentContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
`;

const ItemContainer = styled.div`
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  cursor: pointer;

  &:hover {
    box-shadow: ${color.SURFACE_SHADOW};
    transform: translateY(-1px);
  }

  padding: ${size.MARGIN_1} 0;
  height: 50px;
`;

const HUB_TEXT_DESIGN = {
  text: { size: 'medium', bold: true },
  box: { width: '100%', alignX: 'left', margin: `0 0 5px 0` },
} as const;

const ITEM_TEXT_DESIGN = {
  text: { size: 'medium', color: color.BLACK_2, bold: false },
  box: { alignX: 'left', width: '100%' },
} as const;

const ITEM_ARROW_DESIGN = {
  icon: { size: 'medium', kind: 'outlined' },
  box: { event: { cursor: 'pointer' }, ...(IS_IYAGIGO_MOBILE_VIEW ? { right: '0px' } : { left: '120px' }) },
} as const;

const Home = () => {
  const navigate = useNavigate();
  const isAuthenticated = useTypedSelector((state) => state.rootReducer?.userReducer?.isAuthenticated) ?? false;

  // ############### handler ###############
  const handleGoAccountClick = () => navigate(IYAGIGO_PATH.HUB_ACCOUNT_PATH);
  const handleGoSubscriptionClick = () => navigate(IYAGIGO_PATH.HUB_SUBSCRIPTION_PATH);
  const handleGoHelpClick = () => navigate(IYAGIGO_PATH.HUB_HELP_PATH);
  const handleGoContactClick = () => navigate(IYAGIGO_PATH.HUB_CONTACT_PATH);
  const handleGoApplicationMetadataClick = () => navigate(IYAGIGO_PATH.HUB_APPLICATION_METADATA_PATH);

  return (
    <Wrapper>
      <Scroll direction='y' height={`calc(100%)`}>
        <Gap height={size.MARGIN_2} />
        <TextBlock text='설정' design={HUB_TEXT_DESIGN} />
        <Line color={color.GRAY_2} />
        <HubContentContainer>
          {isAuthenticated && (
            <>
              <ItemContainer onClick={handleGoAccountClick}>
                <TextBlock text='계정 관리하기' design={ITEM_TEXT_DESIGN} />
                <IconBlock icon={'right'} design={ITEM_ARROW_DESIGN} />
              </ItemContainer>
              <Line color={color.GRAY_3} margin={`0 0`} />
            </>
          )}
          <ItemContainer onClick={handleGoHelpClick}>
            <TextBlock text='도움말 보러가기' design={ITEM_TEXT_DESIGN} />
            <IconBlock icon={'right'} design={ITEM_ARROW_DESIGN} />
          </ItemContainer>
          <Line color={color.GRAY_3} margin={`0 0`} />
          <ItemContainer onClick={handleGoContactClick}>
            <TextBlock text='문의 및 의견 보내기' design={ITEM_TEXT_DESIGN} />
            <IconBlock icon={'right'} design={ITEM_ARROW_DESIGN} />
          </ItemContainer>
          <Line color={color.GRAY_3} margin={`0 0`} />
          <ItemContainer onClick={handleGoApplicationMetadataClick}>
            <TextBlock text='앱 정보 보러가기' design={ITEM_TEXT_DESIGN} />
            <IconBlock icon={'right'} design={ITEM_ARROW_DESIGN} />
          </ItemContainer>
          <Line color={color.GRAY_3} margin={`0 0`} />
          <ItemContainer onClick={handleGoSubscriptionClick}>
            <TextBlock text='구독 보러가기' design={ITEM_TEXT_DESIGN} />
            <IconBlock icon={'right'} design={ITEM_ARROW_DESIGN} />
          </ItemContainer>
        </HubContentContainer>
        <Line color={color.GRAY_3} />
      </Scroll>
    </Wrapper>
  );
};

export default Home;
